import OpportunityEventLine from "./OpportunityEventLine";
import OpportunityHashtagRow from "./OpportunityHashtagRow";
import { formatHashtagsString } from "../../../utils/opportunityCard";

export default function OpportunityExpandedContent({
    engagementAngles = [],
    contentAngles = [],
    hashtags = [],
    opportunity = "",
    eventName = "",
}) {
    const hashtagsText = formatHashtagsString(hashtags);
    const opportunityText = String(opportunity ?? "").trim();
    const angles = engagementAngles.length > 0 ? engagementAngles : contentAngles;
    const hasContent =
        Boolean(String(eventName ?? "").trim()) ||
        Boolean(opportunityText) ||
        angles.length > 0 ||
        Boolean(hashtagsText) ||
        (contentAngles.length > 0 && engagementAngles.length > 0);

    if (!hasContent) return null;

    return (
        <div className="space-y-4 border-t border-slate-100 pt-4">
            <OpportunityEventLine eventName={eventName} />

            {opportunityText ? (
                <div className="space-y-2">
                    <p className="mb-0 flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-slate-500 md:text-xs">
                        <i className="bi bi-lightbulb-fill" aria-hidden />
                        Opportunity
                    </p>
                    <p className="mb-0 break-words text-xs leading-relaxed text-slate-700 md:text-sm">
                        {opportunityText}
                    </p>
                </div>
            ) : null}

            {angles.length > 0 ? (
                <div className="space-y-2">
                    <p className="mb-0 flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-teal-700 md:text-xs">
                        <i className="bi bi-chat-quote-fill" aria-hidden />
                        Engagement angles
                    </p>
                    <ul className="mb-0 space-y-1.5">
                        {angles.map((angle, index) => (
                            <li
                                key={`${angle}-${index}`}
                                className="flex gap-2 rounded-lg bg-teal-50/80 px-2.5 py-2 text-xs leading-relaxed text-slate-800 md:text-sm"
                            >
                                <span className="mt-0.5 shrink-0 text-teal-500" aria-hidden>
                                    <i className="bi bi-arrow-right-short text-base leading-none" />
                                </span>
                                <span className="break-words">{angle}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            ) : null}

            {contentAngles.length > 0 && engagementAngles.length > 0 ? (
                <div className="space-y-2">
                    <p className="mb-0 flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-slate-500 md:text-xs">
                        <i className="bi bi-journal-richtext" aria-hidden />
                        Content ideas
                    </p>
                    <div className="flex min-w-0 flex-wrap gap-1.5">
                        {contentAngles.map((angle, index) => (
                            <span
                                key={`${angle}-${index}`}
                                className="inline-block max-w-full whitespace-normal break-words rounded-lg bg-slate-50 px-2 py-0.5 text-[11px] text-slate-600 md:text-xs"
                            >
                                {angle}
                            </span>
                        ))}
                    </div>
                </div>
            ) : null}

            {hashtags.length > 0 ? (
                <div className="space-y-2">
                    <p className="mb-0 flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-slate-500 md:text-xs">
                        <i className="bi bi-hash" aria-hidden />
                        Hashtags
                    </p>
                    <OpportunityHashtagRow hashtags={hashtags} size="sm" />
                </div>
            ) : null}
        </div>
    );
}
